<template lang="pug">
  .toolbar-dropdown-menu
    .btn-group(v-for="(cm, index) in contextMenus")
      li.btn.btn-default.dropdown-toggle.dropdown(type="button" :id="index" data-toggle="dropdown") {{ cm.label }}
        .caret
      ToolbarDropdownTree(ref="treeList" :node="cm" @itemClick="clickHandle($event, cm.label)")
</template>

<script>
import ToolbarDropdownTree from './ToolbarDropdownTree'

export default {
  props: {
    contextMenus: {
      type: Array,
      required: true
    }
  },
  methods: {
    clickHandle(path) {
      this.$emit('selection', path)
    }
  },
  components: {
    ToolbarDropdownTree
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/ToolbarDropdownMenu.vue